import React from 'react';

const ActivityLogModal = ({ isOpen, onClose, logs, isLoading, user }) => {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay" style={{ zIndex: 1000 }}>
            <div className="modal-box form-modal-box" style={{ maxWidth: '700px', maxHeight: '90vh', display: 'flex', flexDirection: 'column' }}>

                <div className="modal-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <h3 style={{ margin: 0, paddingRight: '15px', lineHeight: '1.4' }}>
                        Giám sát hoạt động: <span style={{ color: '#fe6858' }}>{user?.Email}</span>
                    </h3>
                    <button className="close-btn" onClick={onClose} style={{ fontSize: '26px', lineHeight: '1', display: 'flex', flexShrink: 0, marginTop: '-2px' }}>
                        &times;
                    </button>
                </div>

                <div className="modal-body" style={{ padding: '25px', overflowY: 'auto', flex: 1 }}>
                    {isLoading ? (
                        <div style={{ textAlign: 'center', padding: '50px' }}>
                            <i className="fa-solid fa-circle-notch fa-spin fa-2x" style={{ color: '#3498db' }}></i>
                            <p style={{ marginTop: '10px', color: '#666' }}>Đang tải lịch sử hoạt động</p>
                        </div>
                    ) : logs.length === 0 ? (
                        <div style={{ color: '#888', fontStyle: 'italic', textAlign: 'center', padding: '30px' }}>
                            Chưa có hoạt động nào được ghi nhận
                        </div>
                    ) : (
                        <div style={{ position: 'relative', paddingLeft: '30px' }}>
                            <div style={{ position: 'absolute', left: '14px', top: '10px', bottom: '0', width: '2px', backgroundColor: '#e0e0e0' }}></div>

                            {logs.map((item, index) => {
                                let dotColor = '#95a5a6';
                                const contentStr = item.content ? item.content.toLowerCase() : '';

                                if (contentStr.includes('đã gửi duyệt')) dotColor = '#ffb948';
                                else if (contentStr.includes('đã duyệt')) dotColor = '#1e8449';
                                else if (contentStr.includes('yêu cầu chỉnh sửa')) dotColor = '#9b59b6';
                                else if (contentStr.includes('từ chối')) dotColor = '#A52A2A';
                                else if (contentStr.includes('lưu nháp') || contentStr.includes('hủy duyệt')) dotColor = '#7f8c8d';
                                else if (contentStr.includes('xóa') || contentStr.includes('hủy') || contentStr.includes('cảnh báo')) dotColor = '#e74c3c';
                                else if (contentStr.includes('thêm mới') || contentStr.includes('tạo mới') || contentStr.includes('đăng ký')) dotColor = '#2ecc71';
                                else if (contentStr.includes('cập nhật') || contentStr.includes('sửa') || contentStr.includes('bật') || contentStr.includes('tắt')) dotColor = '#3498db';

                                return (
                                    <div key={item.id || index} style={{ position: 'relative', marginBottom: '25px' }}>
                                        <div style={{
                                            position: 'absolute', left: '-31px', top: '4px', width: '12px', height: '12px',
                                            borderRadius: '50%', backgroundColor: dotColor, border: '3px solid #fff',
                                            boxShadow: '0 0 0 1px #e0e0e0', zIndex: 1
                                        }}></div>
                                        <div>
                                            <div style={{ fontSize: '13px', color: '#888', marginBottom: '4px' }}>
                                                {item.time}
                                            </div>
                                            <div style={{ fontSize: '14px', color: '#333', lineHeight: '1.5', wordBreak: 'break-word' }}>
                                                {item.content}
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>

                <div className="modal-footer" style={{ borderTop: '1px solid #e2e8f0', padding: '15px 25px', textAlign: 'right' }}>
                    <button type="button" className="btn-cancel" onClick={onClose}>Đóng</button>
                </div>
            </div>
        </div>
    );
};

export default ActivityLogModal;